import React, {useContext, useMemo} from 'react';
import {ColumnBox} from "../ui/styled";
import styled from "styled-components";
import useQueueId from "../../common/hooks/useQueueId";
import useTimeHook from "../../common/hooks/useTimeHook";
import {useTranslation} from "react-i18next";
import {getTierScore, renderGameTime} from "../../function";
import {SllMatchContext} from "./sllMatchContext";
import {useSelector} from "react-redux";

const Wrapper = styled.div`
  width: 100%;
`;
const GameTypeH5 = styled.h5`
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  color: #fff;

`;

const GameTime = styled.span`
  color: #B2B2C2;
  font-weight: 400;
`;

const GameTimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 13px;
`;
const TimeP = styled.p`
  font-size: 12px;
  margin-top: 4px;
  line-height: 14px;
  color: #B2B2C2;
`;

const WinLoseSpan = styled.span`
  display: inline-block;
  margin-right: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  
  color: #84C7FF;
  
`;
const AvgTierWrapper = styled.div`
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 4px;
  font-weight: 400;
  color: #EEEEEE;
  font-size: 12px;
`;
const SliMatchInfo = ({title}) => {
    const {getMatchName} = useQueueId();
    const {lessMinWithIntl} = useTimeHook()
    const {t} = useTranslation();
    const {match, myMatch,data} = useContext(SllMatchContext);
    const currentLang = useSelector((state) => state.translation.lang);

    const avgTier = useMemo(() => {
        try {
            const playerList = match.participants_list;
            const filterUnrank = playerList.filter((data) => data.tier !== "unranked");
            const combinedPlayerTier = filterUnrank.reduce((sum, cur) => {
                sum += getTierScore(`${cur.tier} ${cur.division}`).num
                return sum;
            }, 0);
            let length = filterUnrank.length;
            if (filterUnrank.length === 0) {
                length = 1;
            }
            return getTierScore(Math.trunc(combinedPlayerTier / length)).obj;
        } catch (e) {
            return {tier: "Unknown", division: 1};
        }
    }, [match]);
    return (
        <Wrapper>
            <ColumnBox height={'auto'} padding={'10px'}>
                <GameTypeH5 status={data?.is_win}>
                    {title ? title : getMatchName(match?.match_basic_dict?.queue_id, match?.match_basic_dict?.tournament_name)}
                </GameTypeH5>
                <TimeP>
                    {lessMinWithIntl((Number(match?.match_basic_dict?.creation_timestamp) + Number(match?.match_basic_dict?.game_duration)) * 1000, currentLang)}
                </TimeP>
                <GameTimeWrapper>
                    <div>
                        <WinLoseSpan status={data?.is_win}>
                            {data?.is_win ? t('summoner.win') : t('summoner.lose')}
                        </WinLoseSpan>
                    </div>
                    <GameTime>
                        {renderGameTime(Number(match?.match_basic_dict?.game_duration))}
                    </GameTime>
                </GameTimeWrapper>
                <AvgTierWrapper>{avgTier.tier} {avgTier.division}</AvgTierWrapper>
                {/*<TeamLuck avgAiScore={avgAiScore} myAiScore={myMatch.ai_score}/>*/}
            </ColumnBox>
        </Wrapper>
    );
};

export default SliMatchInfo;